import * as React from 'react';
import { SVGProps } from 'react';

const SvgStar = (props: SVGProps<SVGSVGElement>) => (
  <svg {...props} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path d="m12 4 2.351 4.764 5.257.764-3.804 3.708.898 5.236L12 16l-4.702 2.472.898-5.236-3.804-3.708 5.257-.764L12 4z" />
  </svg>
);

export default SvgStar;
